module.exports = __webpack_public_path__ + "img/help-circle.0a9c84e1.svg";